module.exports = __webpack_public_path__ + "static/media/notify_icon.1f2b9ded.svg";